import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ASSET_SORT_COLUMNS,
  ILoaneeSuggestions,
  ISearchData,
  SEARCH_FILTERS,
  SearchFilter,
  TICKETS_PLACEHOLDERS
} from '@common/interfaces';
import { Store } from '@ngrx/store';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { maintainFilterType, maintainSearchInput, reset } from 'store/search-state/search.action';
import { selectFilterBy, selectSearchString } from 'store/search-state/search.selector';
import { ISearchState } from 'store/search-state/search.state';


@Component({
  selector: 'app-search-section',
  templateUrl: './search-section.component.html',
  styleUrls: ['./search-section.component.scss'],
  styles: ['.highlight { color: #000}'],
})
export class SearchSectionComponent implements OnInit, OnDestroy {
  @Input() searchOptions!: { title: string; value: string }[];
  @Output() searchData = new EventEmitter<ISearchData>();
  index = '';
  searchStr!: string;
  activeCol!: any;
  suggestionList!: ILoaneeSuggestions[];
  filterBy!: any
  placeholder = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private httpService: CommonHttpService,
    private domSanitizer: DomSanitizer,
    private store: Store<ISearchState>
  ) {
  }
  private searchSubject = new Subject<string>();
  private searchSubscription!: Subscription;
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {

      if (params['assetType']) {
        this.store.dispatch((maintainSearchInput({ searchStr: params['assetType'] })))
        this.store.dispatch((maintainFilterType({
          filterBy: 'ASSET_NAME'
        })))
      }
      const searchStr = this.store.select(selectSearchString)
      searchStr?.subscribe((response) => {
        this.searchStr = response;
      })

      const filterBy = this.store.select(selectFilterBy);
      filterBy?.subscribe((response) => {
        this.filterBy = response
      })

      const matched = this.searchOptions.filter(
        o => o.value === this.filterBy
      );

      this.activeCol = matched.length > 0 
        ? matched 
        : [this.searchOptions[0]];
      this.search()
    });
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe(() => {
      this.search();
    })
  }
  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }
  changeIndex(event: any) {
    this.activeCol = this.searchOptions.filter(
      (option) => option.value === event
    )
  }


  search() {
    this.searchData.emit({
      filterBy:
        this.index || this.activeCol[0]?.value || this.searchOptions[0].value,
      searchStr: this.searchStr,
    });
    if (this.searchStr !== undefined) {
      this.store.dispatch((maintainSearchInput({ searchStr: this.searchStr })))
      this.store.dispatch((maintainFilterType({
        filterBy: this.index || this.activeCol[0]?.value || this.searchOptions[0].value
      })))
    }
  }

  @HostListener('document:keyup.enter', ['$event']) onEnter() {
    this.search();
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const suggestionList = document.getElementById('suggestionList');
    if (suggestionList && !suggestionList.contains(target)) {
      this.suggestionList = [];
    }
  }

  removeClick() {
    this.searchStr = '';
    this.activeCol = this.searchOptions;
    this.store.dispatch(reset())

    this.search();
  }

  searchLoanee() {
    if (this.index === ASSET_SORT_COLUMNS.LOANEE) {
      this.httpService.getUserByEmail(this.searchStr).subscribe({
        next: (value) => {
          this.suggestionList = Object(value)
            .data.slice(0, 4)
            .map((val: any) => ({
              id: val.id,
              name: `${val.firstName} ${val.lastName}`,
              email: val.email,
              employeeId: val.employeeId,
            }));
        },
      });
    }
    this.searchSubject.next(this.searchStr)
  }

  getHighlightedText(text: string, highlight: string) {
    const regex = new RegExp(`(${highlight})`, 'gi');
    const highlightedText = text.replace(
      regex,
      '<span style="color: #000;">$1</span>'
    );
    return this.domSanitizer.bypassSecurityTrustHtml(highlightedText);
  }

  onSuggestionSelect(suggestion: ILoaneeSuggestions) {
    this.searchStr = suggestion.email;
    this.suggestionList = [];
    this.search();
  }
  get searchPlaceholder(): string {
    const selectedValue = this.activeCol[0]?.value as SearchFilter || SEARCH_FILTERS.DEFAULT;
    console.log(selectedValue)
    return TICKETS_PLACEHOLDERS[selectedValue] || TICKETS_PLACEHOLDERS[SEARCH_FILTERS.TICKET_NUMBER];
  }
}
